import zod from "zod";
import { MarginAccountDto } from "../hooks/binance-options-data-service/types/MarginAccountDto";

export function getValidatedMarginAccount(source: unknown): MarginAccountDto | null {
    if (source === null) {
        return null;
    }

    const assetSchema = zod.object({
        asset: zod.string(),
        marginBalance: zod.number(),
        equity: zod.number(),
        available: zod.number(),
        initialMargin: zod.number(),
        maintMargin: zod.number(),
        unrealizedPNL: zod.number(),
        adjustedEquity: zod.number(),
    });

    const greekSchema = zod.object({
        underlying: zod.string(),
        delta: zod.number(),
        theta: zod.number(),
        gamma: zod.number(),
        vega: zod.number(),
    });

    const marginAccountSchema = zod.object({
        time: zod.number(),
        canTrade: zod.boolean(),
        canDeposit: zod.boolean(),
        canWithdraw: zod.boolean(),
        reduceOnly: zod.boolean(),
        asset: zod.array(assetSchema).readonly(),
        greek: zod.array(greekSchema).readonly(),
    });

    const parsed = marginAccountSchema.safeParse(source);

    if (!parsed.success) {
        console.error(
            parsed.error.issues
                .map((issue) => {
                    const path = issue.path.map(String).join(".");
                    return `${path}: ${issue.message}`;
                })
                .join("; ")
        );

        return null;
    }

    return parsed.data;
}
